import { UIBox } from '@/components/ui/Box';
import { Typography } from '@/components/ui/Typography';
import { colors } from '@/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { InfoOutlined } from '@material-ui/icons';

type Props = {
  missingQty: number;
};

const StyledWarning = styled(UIBox)`
  background-color: ${colors.red}22;
  border-radius: 4px;
  padding: 12px;
  margin-top: 12px;
  margin-left: 30px;
  margin-right: 30px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const MissingItemsWarning = ({ missingQty }: Props): JSX.Element => {
  const {t} = useTranslation();

  return (
    <StyledWarning>
      <InfoOutlined />
      <Typography size="sm" font="medium">
        {t('receiving.missingItems.first')}
      </Typography>
      <Typography size="xl" font="heavy" color={'red'}>
        {missingQty}
      </Typography>
      <Typography size="sm" font="medium">
        {t('receiving.missingItems.second')}
      </Typography>
    </StyledWarning>
  );
};
